export var OPEN_REGISTRATION_MODAL = 'OPEN_REGISTRATION_MODAL';
export var CLOSE_REGISTRATION_MODAL = 'CLOSE_REGISTRATION_MODAL';
export var JOIN = 'JOIN';
export var SUCCESS_JOIN = 'SUCCESS_JOIN';
export var FAILURE_JOIN = 'FAILURE_JOIN';
export var CONFIRM_JOIN = 'CONFIRM_JOIN';
export var SUCCESS_CONFIRM_JOIN = 'SUCCESS_CONFIRM_JOIN';
export var FAILURE_CONFIRM_JOIN = 'FAILURE_CONFIRM_JOIN';
export var CHANGE_JOIN_TYPE = 'CHANGE_JOIN_TYPE';



// WEBPACK FOOTER //
// ./src/actions/auth/Join.js